export default __webpack_public_path__ + "static/51990-d64a21fbecc10e2c5cede06d32119350.jpg";